import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConfidence100 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.79484 6.2644C3.31388 7.95155 2.41602 10.1632 2.41602 12.5845",
			stroke: "var(--success-icon-color, #00AD11)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.55664 14.2285C3.02204 16.921 4.6108 19.2287 6.82276 20.6514",
			stroke: "var(--success-icon-color, #00AD11)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5918 21.0001C19.1057 19.6257 20.9361 17.1576 21.4434 14.2356",
			stroke: "var(--success-icon-color, #00AD11)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5858 12.5846C21.5858 10.2617 20.7595 8.13186 19.3848 6.4729",
			stroke: "var(--success-icon-color, #00AD11)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4125 5.46017C16.7142 3.93081 14.4662 3 12.0008 3C9.67411 3 7.54101 3.82908 5.88086 5.20794",
			stroke: "var(--success-icon-color, #00AD11)",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.94 16L5.94 10.77L4.79 11.63L4.14 10.62L6.22 9.13H7.31L7.31 16H5.94ZM10.9731 16.08C10.1731 16.08 9.52647 15.77 9.03314 15.15C8.54647 14.5233 8.30314 13.6633 8.30314 12.57C8.30314 11.51 8.54314 10.66 9.02314 10.02C9.50314 9.37333 10.1531 9.05 10.9731 9.05C11.7865 9.05 12.4365 9.36333 12.9231 9.99C13.4098 10.6167 13.6531 11.4767 13.6531 12.57C13.6531 13.63 13.4131 14.48 12.9331 15.12C12.4531 15.76 11.7998 16.08 10.9731 16.08ZM10.0331 14.22C10.2665 14.62 10.5831 14.82 10.9831 14.82C11.3831 14.82 11.6965 14.6267 11.9231 14.24C12.1498 13.8467 12.2631 13.29 12.2631 12.57C12.2631 11.87 12.1498 11.32 11.9231 10.92C11.6965 10.52 11.3831 10.32 10.9831 10.32C10.5831 10.32 10.2665 10.5167 10.0331 10.91C9.80647 11.2967 9.69314 11.85 9.69314 12.57C9.69314 13.2633 9.80647 13.8133 10.0331 14.22ZM16.9935 16.08C16.1935 16.08 15.5469 15.77 15.0535 15.15C14.5669 14.5233 14.3235 13.6633 14.3235 12.57C14.3235 11.51 14.5635 10.66 15.0435 10.02C15.5235 9.37333 16.1735 9.05 16.9935 9.05C17.8069 9.05 18.4569 9.36333 18.9435 9.99C19.4302 10.6167 19.6735 11.4767 19.6735 12.57C19.6735 13.63 19.4335 14.48 18.9535 15.12C18.4735 15.76 17.8202 16.08 16.9935 16.08ZM16.0535 14.22C16.2869 14.62 16.6035 14.82 17.0035 14.82C17.4035 14.82 17.7169 14.6267 17.9435 14.24C18.1702 13.8467 18.2835 13.29 18.2835 12.57C18.2835 11.87 18.1702 11.32 17.9435 10.92C17.7169 10.52 17.4035 10.32 17.0035 10.32C16.6035 10.32 16.2869 10.5167 16.0535 10.91C15.8269 11.2967 15.7135 11.85 15.7135 12.57C15.7135 13.2633 15.8269 13.8133 16.0535 14.22Z",
			fill: "var(--label-color, #475B5E)"
		})
	]
});
export default SvgConfidence100;
